import type { ContextLoginInfo } from '~/shell/globalContext.ts';

export function formatCustomerNumber(loginInfo: ContextLoginInfo): string {
  return `${loginInfo?.customerNumber}/${loginInfo?.customerCategory?.toString().padStart(2, '0')}`;
}
export function formatCustomerNumberNoSlash(loginInfo: ContextLoginInfo): string {
  return `${loginInfo?.customerNumber}${loginInfo?.customerCategory?.toString().padStart(2, '0')}`;
}
